(() => {
  const normalizeNewsletterAddress = () => document.querySelectorAll('.site-footer__newsletter-description p').forEach(paragraph => {
    paragraph.childNodes.forEach(node => {
      if (node.nodeType === Node.TEXT_NODE) {
        const updated = node.textContent.replace('Sie können den Newsletter jederzeit über den Abmeldelink in jeder E-Mail abbestellen. Weitere Informationen finden Sie in unserer', 'Du kannst Dich jederzeit über den Abmeldelink in jeder E-Mail abmelden. Weitere Informationen findest Du in unserer');
        if (updated !== node.textContent) node.textContent = updated;
      }
    });
  });
  normalizeNewsletterAddress();
  new MutationObserver(normalizeNewsletterAddress).observe(document.documentElement, { childList: true, subtree: true });
  const confirmation = document.querySelector('.shopify-email-marketing-confirmation__container');
  if (confirmation && /Vielen Dank, dass du dich für unsere Mailingliste angemeldet hast|Thank you for subscribing/i.test(confirmation.textContent)) {
    confirmation.classList.add('ps-newsletter-confirmation');
    const content = document.createElement('div');
    content.className = 'ps-newsletter-confirmation__content';
    while (confirmation.firstChild) content.appendChild(confirmation.firstChild);
    confirmation.appendChild(content);
    const heading = content.querySelector('h1, h2');
    if (heading) heading.textContent = 'Willkommen im PeakStyle-Team!';
    const paragraphs = content.querySelectorAll('p');
    if (paragraphs[0]) paragraphs[0].textContent = 'Schön, dass Du dabei bist! Deine Newsletteranmeldung ist bestätigt. Gemeinsam entdecken wir neue Wege, besondere Orte und die passende Ausrüstung für Dein nächstes Abenteuer.';
    if (paragraphs[1]) paragraphs[1].textContent = 'Freue Dich auf neue Kollektionen, Inspiration für Sport und Outdoor und ausgewählte Angebote.';
    const explore = document.createElement('a');
    explore.href = '/collections/all';
    explore.className = 'btn btn--primary ps-newsletter-confirmation__explore';
    explore.textContent = 'Dein nächstes Abenteuer entdecken';
    content.appendChild(explore);
    return;
  }
  const pending = document.querySelector('[data-newsletter-offer-pending]');
  const submitted = new URLSearchParams(location.search).get('customer_posted') === 'true';
  if (pending && submitted) {
    pending.hidden = false;
    pending.scrollIntoView({ block: 'center' });
  }
  const dialog = document.getElementById('PeakStyleNewsletterDialog');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const key = 'peakstyle-newsletter-10-v1-dismissed';
  const week = 7 * 24 * 60 * 60 * 1000;
  let lastTrigger = null;
  let automatic = false;
  const suppressed = () => {
    try { return Date.now() - Number(localStorage.getItem(key) || 0) < week; }
    catch { return false; }
  };
  const markDismissed = () => {
    try { localStorage.setItem(key, String(Date.now())); } catch {}
  };
  const open = (trigger = null, auto = false) => {
    if (dialog.open) return;
    lastTrigger = trigger;
    automatic = auto;
    dialog.showModal();
    if (auto) dialog.querySelector('[data-newsletter-offer-close]').focus();
    else dialog.querySelector('input[type="email"]').focus();
  };
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-newsletter-offer-open], a[href="#PeakStyleNewsletter"]');
    if (!trigger) return;
    event.preventDefault();
    open(trigger);
  });
  dialog.querySelector('[data-newsletter-offer-close]').addEventListener('click', () => dialog.close());
  // Shopify's verification iframe must be able to appear above the page.
  dialog.querySelector('form').addEventListener('submit', () => {
    if (dialog.open) dialog.close();
  }, { capture: true });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    markDismissed();
    if (!automatic && lastTrigger?.isConnected) lastTrigger.focus();
  });
  if (submitted || dialog.querySelector('[data-newsletter-offer-success]')) markDismissed();
  if (!submitted && dialog.querySelector('[data-newsletter-offer-result]')) {
    open();
  } else if (!suppressed() && !document.documentElement.classList.contains('shopify-design-mode')) {
    window.setTimeout(() => {
      if (!document.querySelector('dialog[open], .f-modal[open], .f-popup[open]') && !suppressed()) open(null, true);
    }, 1500);
  }
})();
